export default "__VITE_ASSET__DNptMf7y__"